var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleMapIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17993 14.8154C7.75836 15.5526 8.28481 16.3291 8.75546 17.1393C9.15732 17.9012 9.32484 18.4179 9.61851 19.336C9.79862 19.8432 9.9614 19.9946 10.3114 19.9946C10.6927 19.9946 10.8658 19.7371 10.9994 19.3388C11.277 18.4717 11.4949 17.8101 11.8385 17.1848C12.5128 15.9777 13.3508 14.9051 14.1741 13.8742C14.397 13.5824 15.8381 11.8826 16.4869 10.5414C16.4869 10.5414 17.2842 9.06814 17.2842 7.01054C17.2842 5.08585 16.4979 3.75098 16.4979 3.75098L14.2338 4.3573L12.8589 7.97861L12.5187 8.47795L12.4507 8.56842L12.3603 8.68166L12.2015 8.86253L11.9745 9.0894L10.7502 10.0869L7.68914 11.8543L7.17993 14.8154Z",
    fill: "#34A853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02063 10.294C4.76771 12.0005 6.20837 13.5005 7.18308 14.8169L12.3602 8.68428C12.3602 8.68428 11.6309 9.63818 10.3078 9.63818C8.83409 9.63818 7.64352 8.46134 7.64352 6.97742C7.64352 5.95982 8.25573 5.26074 8.25573 5.26074L4.74134 6.20243L4.02063 10.294Z",
    fill: "#FBBC04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4181 0.31543C14.1375 0.869817 15.6092 2.03369 16.4994 3.74993L12.3618 8.68061C12.3618 8.68061 12.974 7.96889 12.974 6.95761C12.974 5.43914 11.6954 4.30475 10.3141 4.30475C9.00788 4.30475 8.25769 5.25706 8.25769 5.25706V2.1508L12.4181 0.31543Z",
    fill: "#4285F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.96899 2.49401C5.99597 1.26529 7.80305 0 10.2944 0C11.5031 0 12.4137 0.31733 12.4137 0.31733L8.25374 5.25973H5.30632L4.96899 2.49401Z",
    fill: "#1A73E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.02062 10.294C4.02062 10.294 3.33331 8.94804 3.33331 6.99817C3.33331 5.15529 4.04972 3.54439 4.96901 2.49414L8.25609 5.2603L4.02062 10.294Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMapIcon);
export default __webpack_public_path__ + "static/media/google-map-icon.28c33a07a9a05cf3b0440a106505c6c2.svg";
export { ForwardRef as ReactComponent };